function homepage() {
	const mainHomepage = document.querySelector('main.homepage');
	if (!mainHomepage) return;

	initHeroSwiper();
	initOrganisationsSwiper();

	function initHeroSwiper() {
		const heroSwiperContainer = mainHomepage.querySelector('.hero-swiper');
		if (!heroSwiperContainer) return;
		new Swiper(heroSwiperContainer, {
			spaceBetween: 30,
			autoplay: {
				delay: 6000,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		});
	}

	function initOrganisationsSwiper() {
		const organisationsSwiperContainer = document.querySelector('.organisations-swiper');
		if (!organisationsSwiperContainer) return;

		const swiperWrapper = organisationsSwiperContainer.querySelector('.swiper-wrapper');
		const swiperWrapperScrollWidth = swiperWrapper.scrollWidth;
		const swiperContainerWidth = organisationsSwiperContainer.getBoundingClientRect().width;
		const shouldAutoplay = swiperWrapperScrollWidth > swiperContainerWidth;

		new Swiper(organisationsSwiperContainer, {
			slidesPerView: 'auto',
			spaceBetween: 10,
			speed: 6000,
			observer: true,
			observeParents: true,
			freeMode: true,
			...(shouldAutoplay
				? {
						loop: true,
						autoplay: {
							delay: 0,
							disableOnInteraction: false,
						},
					}
				: {}),
		});
	}
}
